module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-menu.aabff6cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-arrow-down-menu.svg
// module id = 528
// module chunks = 0